import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import type { ReactNode } from 'react'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      // Data is trusted for five minutes: moving between apps and coming back
      // shows what was already fetched instead of asking again.
      staleTime: 1000 * 60 * 5,
      // ...and it is kept for half an hour after the last screen using it
      // unmounts. The default is five minutes, which meant a detour long
      // enough to read one note made the way back a cold load.
      gcTime: 1000 * 60 * 30,
    },
  },
})

export function QueryProvider({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  )
}
